<template>
    <div class="head">
        <div class="head-logo" @click="gotoHome">
            <img :src="type == 'b'?'../assets/icon_logo.png':'../assets/icon_zk_logo.png'" alt="" />
            <p>{{type == 'b'?'伴伴直播':'掌控娱乐'}}</p>
        </div>
        <el-menu :default-active="routePath" class="el-menu-demo" mode="horizontal" background-color="#000"
            active-text-color="#fff" text-color="#fff" :router="true">
            <el-menu-item index="/"><span>首页</span></el-menu-item>
            <el-menu-item index="/interactive"><span>互动空间</span></el-menu-item>
            <el-menu-item index="/playRoutine"><span>游玩日常</span></el-menu-item>
            <el-menu-item index="/helpCenter"><span>帮助中心</span></el-menu-item>
            <!-- <el-menu-item index="/account"><span>账户充值</span></el-menu-item> -->
        </el-menu>
        <div class="head-user" @click="gotoLogin" v-if="isToken">
            <div class="user-login">登录</div>
            <div class="user-reg">注册</div>
        </div>
        <el-dropdown v-else>
            <div class="dropdown-div">
                <img :src="userInfo.headPic ? userInfo.headPic : logoImg" alt="" />
                <span class="el-dropdown-link">
                    {{ userInfo.userNickname
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
            </div>
            <el-dropdown-menu slot="dropdown">
                <div class="popover-box">
                    <img class="user-logo" :src="userInfo.headPic ? userInfo.headPic : type == 'b'?logoImg:zkLogoImg" alt="" />
                    <div class="user-vip">
                        <span class="user-name">{{
                            userInfo.userNickname
                            }}</span>
                        <div class="vip-lv">
                            <img :src="userInfo.totalGrade == 1
                                ? lv1
                                : userInfo.totalGrade == 2
                                    ? lv2
                                    : userInfo.totalGrade == 3
                                        ? lv3
                                        : userInfo.totalGrade == 4
                                            ? lv4
                                            : userInfo.totalGrade == 5
                                                ? lv5
                                                : userInfo.totalGrade == 6
                                                    ? lv6
                                                    : userInfo.totalGrade == 7
                                                        ? lv7
                                                        : lv8
                                " alt="" />
                            <span>{{ userInfo.totalGradeName }}</span>
                        </div>
                    </div>
                    <!-- <div class="user-num">
                        <span>我的余额</span>
                        <div class="num-money" @click="gotoMoney">充值</div>
                    </div> -->
                    <div class="blood-num">
                        <img src="../assets/money-blood.png" alt="" />
                        <span>{{ userInfo.gold }}</span>
                    </div>
                    <div class="user-out" @click="loginOut">
                        <img src="../assets/out-icon.png" alt="" />
                        <span>退出登录</span>
                    </div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import logoImg from "../assets/down-logo.png";
import zkLogoImg from '../assets/down-zk-logo.png';
import lv1 from "../assets/lv1.png";
import lv2 from "../assets/lv2.png";
import lv3 from "../assets/lv3.png";
import lv4 from "../assets/lv4.png";
import lv5 from "../assets/lv5.png";
import lv6 from "../assets/lv6.png";
import lv7 from "../assets/lv7.png";
import lv8 from "../assets/lv8.png";
import { logoutApi, usercoinApi } from "../api/api.js";
export default {
    name: "Head",
    data() {
        return {
            routePath: "/",
            isToken: true,
            token: '',
            userInfo: {},
            zkLogoImg,
            logoImg,
            lv1,
            lv2,
            lv3,
            lv4,
            lv5,
            lv6,
            lv7,
            lv8,
        };
    },
    components: {},
    computed:{
        type() {
            return window.location.hostname.indexOf('yaojing') >=0?'b':'z';
        }
    },
    mounted() {
        const token = this.$store.getters.getToken;
        const userInfo = this.$store.getters.getUserInfo;

        this.userInfo = userInfo;
        this.routePath = this.$route.path;
        if (token) {
            this.isToken = false;
            this.usercoinInfo()
        } else {
            this.isToken = true;
        }
    },
    watch: {
        $route(to, from) {
            const token = this.$store.getters.getToken;
            const userInfo = this.$store.getters.getUserInfo;

            this.userInfo = userInfo;
            this.routePath = to.path;
            if (token) {
                this.usercoinInfo()
                this.isToken = false;
            } else {
                this.isToken = true;
                if (to.path == "/account") {
                    this.$message({
                        message: "请先登录",
                        type: "warning",
                    });
                    this.$router.push({ path: "/login" });
                }
            }
        },
    },
    methods: {
        gotoLogin() {
            this.$router.push({ path: "/login" });
        },
        gotoMoney() {
            this.$router.push({ path: "/account" });
        },
        gotoHome() {
            this.$router.push({ path: "/" });
        },
        async usercoinInfo() {
            const token = this.$store.getters.getToken;
            const res = await usercoinApi({
                token
            })
            this.$store.commit("SET_USERINFO", res.data.data);
        },
        async loginOut() {
            const res = await logoutApi({
                token: this.$store.getters.getToken,
            });
            if (res) {
                this.$message({
                    message: "退出登录成功",
                    type: "success",
                });
                this.isToken = true;
                this.$store.commit("RESET_STATE");
                localStorage.removeItem("token");
                this.$router.push({ path: "/" });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.head {
    width: 100vw;
    height: 110px;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-menu-demo {
    height: 100%;
    display: flex;
    align-items: center;
    background: #000;
    color: #fff;
    margin-right: 100px;
}

.el-menu.el-menu--horizontal {
    border: none;
}

::v-deep .el-menu--horizontal>.el-menu-item {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 0 40px;
}

::v-deep .el-menu-item.is-active {
    border-bottom: 6px solid #ff9000 !important;
    /* 修改为你需要的颜色和宽度 */
}

.head-logo {
    /*img {
        width: 200px;
        height: 54px;
        padding-right: 100px;
    }*/
    width: 200px;
    height: 54px;
    display: flex;
    align-items: center;
    padding-right: 100px;
    img{
        display: block;
        height: 54px;
        border-radius: 10px;
    }
    p {
        font-size: 32px;
        color: #fff;
        padding-left: 15px;
        font-weight: 600;
        font-style: italic
    }
}

.head-user {
    padding: 5px 15px;
    font-size: 14px;
    color: #ffffff;
    background: #ff8803;
    display: flex;
    align-items: center;
    cursor: pointer;

    // margin-left: 100px;
    .user-login {
        padding-right: 10px;
        border-right: 1px solid #fff;
    }

    .user-reg {
        padding-left: 10px;
    }
}

.dropdown-div {
    display: flex;
    align-items: center;

    img {
        width: 50px;
        height: 50px;
        border-radius: 25px;
        margin-right: 10px;
    }
}

.el-dropdown-link {
    cursor: pointer;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 18px;
}

.popover-box {
    width: 290px;
    height: 270px;
    text-align: center;
    padding: 20px;

    .user-logo {
        width: 80px;
        height: 80px;
        border-radius: 40px;
    }

    .user-vip {
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ff9000;
        padding: 20px 0;

        .user-name {
            padding-right: 20px;
            font-size: 20px;
            font-weight: bold;
        }

        .vip-lv {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #898989;

            img {
                width: 21px;
                height: 23px;
                padding-right: 10px;
            }
        }
    }

    .user-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;

        span {
            font-size: 18px;
        }

        .num-money {
            width: 80px;
            height: 30px;
            background: #ff9000;
            border-radius: 14px;
            color: #fff;
            font-size: 18px;
            text-align: center;
            line-height: 30px;
            font-weight: bold;
            cursor: pointer;
        }
    }

    .blood-num {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        img {
            width: 30px;
            // height: 30px;
            padding-right: 5px;
        }

        span {
            font-size: 30px;
            font-weight: bold;
        }
    }

    .user-out {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: 20px;
        cursor: pointer;

        img {
            width: 13px;
            height: 15px;
        }

        span {
            color: #aaa9a9;
            font-size: 16px;
            padding-left: 5px;
        }
    }
}
</style>
